import axios from 'axios';
import { Constants } from './Constants';
import { AppActionCreators } from '../store';

const instance = axios.create({
  baseURL: Constants.apiRoot,
  withCredentials: true // Permite trimiterea cookie-urilor in request-uri
});

let storeRef: any = null;

export const setAxiosStore = (store: any) => {
  storeRef = store;
};

instance.interceptors.request.use(
  (config) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    config.headers.locale = localStorage.getItem('locale');

    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

let isSessionExpiredHandled = false;

const handleExpiredSession = () => {
  if (isSessionExpiredHandled) return;

  isSessionExpiredHandled = true;

  if (storeRef) {
    storeRef.dispatch(AppActionCreators.LogoutCredentials());
  } else {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.removeItem('safari_auth_token');
    sessionStorage.removeItem('safari_auth_refreshToken');
    sessionStorage.removeItem('safari_auth_user');
  }

  window.location.href = '/auth/login?sessionExpired=true';
};

instance.interceptors.response.use(
  function (response) {
    if (response.status === 204 && response.data === '') {
      response.data = null;
    }

    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      handleExpiredSession();
    }
    return Promise.reject(error);
  }
);

export default instance;
